import type { FC } from 'react'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pushGtmEvent } from '@/logic/metrika/helpers'
import type { IFormattedGtmEventPayload } from '@/logic/metrika/interfaces'
import { FieldEvaluationReportDialogLauncher } from '@/pages/Financing/components/FieldEvaluationReportDialogLauncher'
import { useSearchQuery } from '@/router/hooks/useSearchQuery'
import { useJournalUrlParams } from '@/utils/infoportal/hooks/useJournalUrlParams'
import { JournalByRubrics, JournalBySearch, JournalByTags, JournalIndex } from './components'
import { messages } from './messages'
import './styles.scss'

const Journal: FC = () => {
  const { rubricId, tagId } = useJournalUrlParams()
  const { pathname } = useLocation()
  const query = useSearchQuery()
  const searchTextQuery = query.get('searchText')

  const shouldShowIndexPage = !rubricId && !tagId && !searchTextQuery

  useEffect(() => {
    pushGtmEvent<IFormattedGtmEventPayload>({
      event: 'userEvent',
      pagePart: 'content',
      blockName: null,
      eventCategory: 'interactions',
      eventAction: 'viewing',
      eventLabel: 'pageView',
      eventContext: `pp:${pathname};pt:other`,
      eventStatus: 'success',
      eventEcommerce: null,
      eventNonInteraction: '0',
      firingOptions: 'oncePerEvent',
      ecommerce: null,
    })
  }, [pathname])

  return (
    <section className="journal-page journal-block-swipe-sides">
      {shouldShowIndexPage && <JournalIndex />}
      {!rubricId && !tagId && searchTextQuery && <JournalBySearch searchText={searchTextQuery} />}
      {rubricId && <JournalByRubrics rubricId={Number(rubricId)} />}
      {tagId && <JournalByTags tag={Number(tagId)} />}
      <FieldEvaluationReportDialogLauncher comment={messages.fieldEvaluationReportDialog.comment} />
    </section>
  )
}

export default Journal
